// src/components/common/Pagination/Pagination.jsx
import React from "react";
import "./Pagination.css";

const DOTS = "…";

function range(start, end) {
  const result = [];
  for (let i = start; i <= end; i++) {
    result.push(i);
  }
  return result;
}

// Build a compact list of page numbers (with ellipses) so the control never
// grows wide enough to push the surrounding layout off-screen, no matter how
// many pages there are. e.g. 1 … 18 19 20 … 40
function getPaginationRange(currentPage, totalPages, siblingCount) {
  // first + last + current + (siblings on each side) + 2 ellipsis slots
  const totalPageNumbers = siblingCount * 2 + 5;

  // Few enough pages that everything fits — show them all.
  if (totalPages <= totalPageNumbers) {
    return range(1, totalPages);
  }

  const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
  const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPages);

  // Only show a "…" when it actually hides more than one page.
  const shouldShowLeftDots = leftSiblingIndex > 2;
  const shouldShowRightDots = rightSiblingIndex < totalPages - 1;

  if (!shouldShowLeftDots && shouldShowRightDots) {
    const leftItemCount = 3 + 2 * siblingCount;
    return [...range(1, leftItemCount), DOTS, totalPages];
  }

  if (shouldShowLeftDots && !shouldShowRightDots) {
    const rightItemCount = 3 + 2 * siblingCount;
    return [1, DOTS, ...range(totalPages - rightItemCount + 1, totalPages)];
  }

  return [1, DOTS, ...range(leftSiblingIndex, rightSiblingIndex), DOTS, totalPages];
}

export default function Pagination({
    currentPage,
    totalPages,
    pageSize,
    totalItems,
    onPageChange
  
}) {
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(start + pageSize - 1, totalItems);
  const pageItems = getPaginationRange(currentPage, totalPages, 1);
  const handleClick = function (page) {
    if (onPageChange) {
      onPageChange(page);
    }
  };

  return (
    <div className="pagination-container">

      {/* Left side summary */}
      <span className="pagination-summary">
        Showing <span className="pagination-bold">{start}-{end}</span> of{" "}
        <span className="pagination-bold">{totalItems}</span>
      </span>

      {/* Right side list */}
      <ul className="pagination-list">
        {/* Previous */}
        <li>
          <button
            className="pagination-btn pagination-prev"
            disabled={currentPage === 1}
            onClick={function () {
              if (currentPage > 1) handleClick(currentPage - 1);
            }}
          >
            Previous
          </button>
        </li>

        {/* Page Numbers (windowed with ellipses) */}
        {pageItems.map(function (item, index) {
          if (item === DOTS) {
            return (
              <li key={"dots-" + index} className="pagination-dots">
                <span className="pagination-ellipsis">{DOTS}</span>
              </li>
            );
          }

          const isActive = item === currentPage;

          return (
            <li key={item}>
              <button
                className={
                  "pagination-btn " +
                  (isActive ? "pagination-active" : "")
                }
                onClick={function () {
                  handleClick(item);
                }}
              >
                {item}
              </button>
            </li>
          );
        })}

        {/* Next */}
        <li>
          <button
            className="pagination-btn pagination-next"
            disabled={currentPage === totalPages}
            onClick={function () {
              if (currentPage < totalPages) handleClick(currentPage + 1);
            }}
          >
            Next
          </button>
        </li>
      </ul>
    </div>
  );
}
